export const apiAddress = () => {
  console.log(`NODE_ENV is ${process.env.NODE_ENV}`);
  if (process.env.NODE_ENV === "development") {
    return `${window.location.protocol}//${window.location.hostname}:8080/api`;
  } else {
    return window.location.protocol + "//" + window.location.hostname + "/api";
  }
};

export const berthsAddress = apiAddress() + "/berths";
export const berthsSearchAddress = berthsAddress + "/search";
export const myBerthsAddress = berthsAddress + "/myberth";
export const myBerthStatusesAddress = apiAddress() + "/berths/myberthstatuses";
export const statusAddress = apiAddress() + "/berths/status";
export const harboursAddress = apiAddress() + "/harbours";
export const harboursSearchAddress = harboursAddress + "/search?q=";
export const trailsSearchAddress = apiAddress() + "/trails/search";
export const signinAddress = apiAddress() + "/signin";
export const userinfoAddress = apiAddress() + "/userinfo";
export const admininfoAddress = apiAddress() + "/admin/admininfo";
export const boatinfoAddress = apiAddress() + "/boatinfo";
export const signoutAddress = apiAddress() + "/signout";
export const csrfAddress = apiAddress() + "/csrf";
export const bookingsAddress = apiAddress() + "/bookings";
export const userFutureBookingAddress = bookingsAddress + "/userfuturebookings";
export const cancelBookingAddress = bookingsAddress + "/cancel";

export const signupAddress = apiAddress() + "/bookingusers";
export const verifyRegistrationEmailAddress =
  apiAddress() + "/confirmregistration";
export const validateEmailAddress = apiAddress() + "/validateemail";
export const mayResendRerificationEmailAddress =
  apiAddress() + "/mayresendverification";
export const resendVerificationEmailAddress =
  apiAddress() + "/resendverification";
export const forgotPasswordAddress = apiAddress() + "/forgotpassword";
export const resetPasswordAddress = apiAddress() + "/resetpassword";
export const markPasswordTokenFetchedAddress =
  apiAddress() + "/fetchpasswordtoken";
export const adminGetBerthStatusFeeSupportAddress =
  apiAddress() + "/admin/berths/statusoverview";
